import { useState } from 'react'
import { Button, Spinner, Tooltip } from '@fluentui/react-components'
import { useProjektprognosEditingContext } from '../../context/ProjektprognosEditingContext'
import { useCompleteProjectForecast } from '../../fetchData/mutations/useCompleteProjectForecast'
import { ActionConfirmationModal } from '../Shared/ActionConfirmationModal'
import styles from './CompletePeriodReportButton.module.css'

const CompletePeriodReportButton = () => {
  const { selectedPeriodReport } = useProjektprognosEditingContext()
  const reportGuid = selectedPeriodReport?.id || null
  const { mutate, isPending, error, reset } =
    useCompleteProjectForecast(reportGuid)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const isOngoingStatus = selectedPeriodReport?.status === 'Ongoing'
  const isDisabled = !reportGuid || !isOngoingStatus

  const handleOpen = () => {
    reset()
    setIsModalOpen(true)
  }

  const handleClose = () => {
    reset()
    setIsModalOpen(false)
  }

  const handleConfirm = () => {
    if (!reportGuid) return

    mutate(undefined, {
      onSuccess: () => {
        setIsModalOpen(false)
      },
    })
  }

  return (
    <>
      <Tooltip
        content="Färdigställ rapporten och lås för redigering"
        relationship="label"
      >
        <Button
          className={styles.button}
          onClick={handleOpen}
          disabled={isDisabled}
          appearance="secondary"
        >
          {isPending && <Spinner size="tiny" className={styles.spinner} />}
          Färdigställ prognos
        </Button>
      </Tooltip>

      <ActionConfirmationModal
        isOpen={isModalOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isPending}
        error={error}
        onReset={reset}
        title="Färdigställ prognos"
        message="När du färdigställer rapporten så låser du prognosen för redigering. Är du säker på att du vill färdigställa?"
        confirmLabel="Färdigställ"
      />
    </>
  )
}

export default CompletePeriodReportButton
